/**
 * ClearedTile - a single "cleared this week" stat tile (After Evo action /
 * Silently). The value colour and caption are passed in so the parent owns
 * the wording; the model is that sync confirms the clear, not a person.
 */
import React from 'react'
import { Box, Typography } from '@mui/material'

interface Props {
  label: string
  value: number
  caption: string
  valueColor: string
}

const ClearedTile: React.FC<Props> = ({ label, value, caption, valueColor }) => (
  <Box
    sx={{
      flex: '0 1 180px',
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 2,
      p: 2,
      bgcolor: 'background.paper',
    }}
  >
    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
      {label}
    </Typography>
    <Typography variant="h4" sx={{ fontWeight: 700, color: valueColor, my: 0.25 }}>
      {value.toLocaleString()}
    </Typography>
    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
      {caption}
    </Typography>
  </Box>
)

export default ClearedTile
